import useSeeding from 'services/seeding/seedingResponses';
import useSeedingInfo from 'hooks/useSeedingInfo';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';

import { Spinfinity, OrderKitButton } from 'components';
import { SeedingCard } from './SeedingCard';

import styles from './Seeding.module.scss';

export const SeedingSample = () => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();

  const { data, isLoading, isError } = useSeeding({ kitId: currentKitId });
  const noSharedTaxaRelAbundance = data?.sharedTaxaRelAbundance === null;

  const { babyTA, momTA, matchSeedingCriteria } = useSeedingInfo();
  const displaySeeding = matchSeedingCriteria && !noSharedTaxaRelAbundance;

  if (isError) throw new Error();
  if (!displaySeeding) {
    return (
      <div className={styles.backgroundBlur}>
        <div
          className={`flex flex-column justify-content-center align-items-center ${styles.bgContainer}`}
        >
          <div className={styles.bgImage} />
          <p className={styles.overlayText}>
            Submit a gut sample for both mom and baby within the first 6 months
            to see what seeded.
          </p>

          {(currentKit?.ttc || currentKit?.pregnant) && (
            <OrderKitButton classNames={styles.overlayText}>
              Order Your Tiny&nbsp;Gut&nbsp;Kits
            </OrderKitButton>
          )}

          <div className={styles.blurImageContainer} />
        </div>
      </div>
    );
  }

  return (
    <>
      {!data || isLoading ? (
        <Spinfinity />
      ) : (
        <SeedingCard
          seedingData={data}
          birthMotherFirstName={momTA?.first_name ?? 'Mother'}
          babyFirstName={babyTA?.first_name ?? 'Baby'}
        />
      )}
    </>
  );
};
